export const LOADING_CLASS_NAME = 'loading';
export const PRODUCT_IN_CART_CLASSNAME = 'product-added';



// WEBPACK FOOTER //
// ./frontend/src/constants.js